import {  fetchWrapper } from '@/_helpers';

export const conferenceApi = {
    guestJoin: (conferenceId, data) => fetchWrapper.post(`conference/${conferenceId}/guest/join`, data),
    guestRequest: (conferenceId) => fetchWrapper.post(`conference/${conferenceId}/guest/request`),
    guestApprove: (conferenceId, data) => fetchWrapper.post(`conference/${conferenceId}/guest/approve`, data),
};
